import script from "./ProductTypeSide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTypeSide.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTypeSide.vue?vue&type=style&index=0&id=e2000c46&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2000c46"]])

export default __exports__